export default "__VITE_ASSET__9xnWGwyh__"